import type { ReactNode } from 'react'
import React from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import map from 'lodash/map'
import { useCarrierRate } from '../../hooks/useCarrierRate'
import type { CarrierRate } from '../../types'

import { useShippingRatePanelContext } from './Context'
export const CarrierTabs = (props: {
  children: (carrierRates: CarrierRate[], onSelect: (carrierRate: CarrierRate) => void) => ReactNode
}) => {
  const [_onSelect] = useCarrierRate()

  const shippingRateContext = useShippingRatePanelContext()
  const [groupedByCarrier] = shippingRateContext.groupedByCarrierRate

  return (
    <Tabs variant="underline" defaultActiveKey={Object.keys(groupedByCarrier)?.[0]} id="order-tab">
      {map(Object.keys(groupedByCarrier), (item) => {
        const carrierRates = groupedByCarrier[item]

        const onSelect = (carrierRate: CarrierRate) => {
          _onSelect({ carrierRate })
          // setShippingOptions({ carrierRate: { ...carrierRate, hasSelected: true } })
        }

        return (
          <Tab eventKey={item} title={item} mountOnEnter key={item}>
            <div className="py-2">{props.children(carrierRates, onSelect)}</div>
          </Tab>
        )
      })}
    </Tabs>
  )
}
